import React, { PureComponent } from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    // DialogContent,
    // DialogContentText,
    DialogTitle,
} from '@material-ui/core'
import ObjectsToCsv from 'objects-to-csv';
import { saveAs } from 'file-saver';
import { getDate, getMonth, getHours, getMinutes, getSeconds } from "date-fns";
import * as XLSX from 'xlsx';

import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

class ModalForDownloadInTable extends PureComponent {

    async downloadDataAsCsv () {
        // find those points within polygon
        const { rows } = this.props;

        let csv = new ObjectsToCsv(rows);
        let res = await csv.toString();
        const csvBlob = new Blob([res], { type: 'text/csv' });
        const date = new Date();
        saveAs(csvBlob, `HouseATLData_${getMonth(date)}_${getDate(date)}_${getHours(date)}-${getMinutes(date)}-${getSeconds(date)}.csv`);
    }

    async downloadDataAsXlsx () {
        // find those points within polygon
        const { rows } = this.props;

        const sheet = XLSX.utils.json_to_sheet(rows),
        workbook = { Sheets: {  }, SheetNames: [] };

        XLSX.utils.book_append_sheet(workbook, sheet, "sheet 1");

        const res = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

      
        const csvBlob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
        const date = new Date();
        saveAs(csvBlob, `HouseATLData_${getMonth(date)}_${getDate(date)}_${getHours(date)}-${getMinutes(date)}-${getSeconds(date)}.xlsx`);
    }

    render() {
        const { title, onClose, visible, maxWidth } = this.props;

        return (
            <Dialog
                maxWidth={maxWidth}
                open={visible}
                onClose={onClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{title}
                    <IconButton onClick={() =>{onClose()}}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
        
                <DialogActions>
         
                    <Button
                        style={{
                          // minWidth: "99px", 
                          marginTop: "10px",
                          color:"#fff",
                          backgroundColor:"black",
                          // padding: "6px 16px",
                          fontSize: "0.875rem",
                          minWidth: "64px",
                          boxSizing: "border-box",
                          transition: "background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
                          fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
                          fontWeight: "500",
                          lineHeight: "1.75",
                          borderRadius: "4px",
                          letterSpacing: "0.02857em",
                          border: "0",
                          padding: "8px 24px",
                          boxShadow: "none",
                          textTransform: "uppercase",
                        
                          marginLeft: "20px"
                        }}

                        onClick={() => {this.downloadDataAsCsv(); onClose()}}

                        id="downloadAsCSV"
                        >
                            CSV
                    </Button>
                    <Button
                        style={{
                          // minWidth: "99px", 
                          marginTop: "10px",
                          color:"#fff",
                          backgroundColor:"black",
                          // padding: "6px 16px",
                          fontSize: "0.875rem",
                          minWidth: "64px",
                          boxSizing: "border-box",
                          transition: "background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
                          fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
                          fontWeight: "500",
                          lineHeight: "1.75",
                          borderRadius: "4px",
                          letterSpacing: "0.02857em",
                          border: "0",
                          padding: "8px 24px",
                          boxShadow: "none",
                          textTransform: "uppercase",
                        
                          marginRight: "20px"
                        }}

                        onClick={() => {this.downloadDataAsXlsx();onClose()}}

                        id="downloadAsXLSX"
                        >
                            XLSX
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

export default ModalForDownloadInTable;
